module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_prp03-ac4aad11863e9cdc6e83ed5f7dc7f9fd.svg";